export class AcompanhamentoItemModel {
  constructor(hora, nome, nomeLogin, email, conteudo) {
    this.hora = hora;
    this.nome = nome;
    this.nomeLogin = nomeLogin;
    this.email = email;
    this.conteudo = conteudo;
  }
}
